import type { WidgetType } from '../../../Widget';
import type { IInputWidget } from '../IInputWidget';

interface IDateWidgetFormat {
  /**
   * Codice del formato, salvato nel widget
   */
  key: string;
  /**
   * Formato per la serializzazione; utilizzato per il salvataggio del valore
   * nei valori JSON, ed è passato a `stringDate` per la validazione.
   */
  serializeFormat: string;
  /**
   * Visualizzazione del formato; utilizzato per la visualizzazione del valore
   * nell'interfaccia utente.
   */
  datePickerFormat: string;
  /**
   * Nome del formato, per la selezione del formato
   */
  label: string;
  /**
   * Placeholder per l'input
   */
  placeholder: string;
}

export const DateWidgetFormats = [
  {
    key: 'Date',
    serializeFormat: 'YYYY-MM-DD',
    datePickerFormat: 'DD/MM/YYYY',
    label: 'Data (GG/MM/AAAA)',
    placeholder: 'GG/MM/AAAA',
  },
  {
    key: 'DateTime',
    serializeFormat: 'YYYY-MM-DD[T]HH:mm:ss',
    datePickerFormat: 'DD/MM/YYYY HH:mm',
    label: 'Data e ora (GG/MM/AAAA HH:mm)',
    placeholder: 'GG/MM/AAAA HH:mm',
  },
  {
    key: 'DateTimeSeconds',
    serializeFormat: 'YYYY-MM-DD[T]HH:mm:ss',
    datePickerFormat: 'DD/MM/YYYY HH:mm:ss',
    label: 'Data e ora con secondi (GG/MM/AAAA HH:mm:ss)',
    placeholder: 'GG/MM/AAAA HH:mm:ss',
  },
] as const satisfies IDateWidgetFormat[];

// Di default, il formato è quello della data senza ora
export const DefaultWidgetDateFormat = DateWidgetFormats.find(
  f => f.key === 'Date',
)!;

export function getWidgetDateFormat(widget: IDateWidget) {
  return (
    DateWidgetFormats.find(f => f.key === widget.dateFormat) ??
    DefaultWidgetDateFormat
  );
}

export type DateWidgetFormat = (typeof DateWidgetFormats)[number]['key'];

/**
 * Input Data
 */
export interface IDateWidget extends IInputWidget {
  type: WidgetType.Date;
  dateFormat: DateWidgetFormat | null | undefined;
}
